module.exports = __webpack_public_path__ + "static/media/avatar.df3dc14e.png";